import React, { useContext, useEffect, useState } from "react";
import "./Candidateform.css";
import Loginheader from "../../components/loginheader/Loginheader";
import BackgroundImg from "../../assests/interview.jpg";
import { motion } from "framer-motion";
import submitLogo from "../../assests/submit.png";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../../context/AuthContext";
import { Modal, Input, Col, Row, Form, Button, Radio } from "antd";

export default function Candidateform() {
    const { c_id } = useParams();
    const { backUrl } = useContext(AuthContext);
    const [candidateExp, setCandidateExp] = useState("fresher");

    const [previousEmpCode, setPreviousEmpCode] = useState("");
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedOption, setSelectedOption] = useState(false);
    const [askEmployee, setAskEmployee] = useState(true);
    const [isRejoined, setIsRejoined] = useState(false);

    const [prevEmp, setPrevEmp] = useState(null)

    // ⭐ NEW: Reference History Dynamic State
    const [referenceHistory, setReferenceHistory] = useState([
        { referal_name: "", referal_designation: "", referal_mobile_number: "", referal_email_id: "" }
    ]);

    const handleReferenceChange = (index, field, value) => {
        const updated = [...referenceHistory];
        updated[index][field] = value;
        setReferenceHistory(updated);
    };

    const addReferenceRow = () => {
        setReferenceHistory([
            ...referenceHistory,
            { referal_name: "", referal_designation: "", referal_mobile_number: "", referal_email_id: "" }
        ]);
    };

    const removeReferenceRow = (index) => {
        if (referenceHistory.length === 1) {
            toast.warn("At least one reference is required");
            return;
        }
        setReferenceHistory(referenceHistory.filter((_, i) => i !== index));
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({ ...formData, [name]: files ? files[0] : value });
    };

    const [formBlocked, setFormBlocked] = useState(null);

    const validateDuplication = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/candidate-form/view/${c_id}/`);
            if (res.data?.status === 'already_submitted' || res.data?.message) {
                setFormBlocked(res.data.message || 'This form has already been submitted.');
            } else {
                setFormBlocked(false);
            }
        } catch (error) {
            const msg = error?.response?.data?.message || error?.response?.data?.detail || 'This link is invalid or has expired.';
            setFormBlocked(msg);
        }
    };

    useEffect(() => {
        validateDuplication();
    }, []);

    const verifyEmployee = async () => {
        const res = await axios.get(`${backUrl}/api/emp/employees/?emp_code=${previousEmpCode}&status=Resigned`);
        setPrevEmp(res.data.results);
    }


    const validate = () => {
        let newErrors = {};

        if (!/\S+@\S+\.\S+/.test(formData.email_id)) {
            newErrors.email = "Invalid email format";
            toast.warn("Invalid email format");
        }

        if (!/^\d{12}$/.test(formData.aadhaar)) {
            newErrors.aadhaar = "Aadhaar must be exactly 12 digits";
            toast.warn("Aadhaar must be exactly 12 digits");
        }

        if (formData.pan && !/^[A-Z]{5}[0-9]{4}[A-Z]$/i.test(formData.pan)) {
            newErrors.pan = "PAN must be in format: 5 letters, 4 digits, 1 letter";
            toast.warn("PAN must be in format: 5 letters, 4 digits, 1 letter");
        }

        if (!/^\d{10}$/.test(formData.mobile_number)) {
            newErrors.mobile_number = "Mobile number must be 10 digits";
            toast.warn("Mobile number must be 10 digits");
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            const data = new FormData();

            Object.entries(formData).forEach(([key, value]) => {
                data.append(key, value);
            });

            const isOldEmployee = selectedOption === true && !!prevEmp && prevEmp.length > 0;
            const oldCode = isOldEmployee ? previousEmpCode : "";

            data.append("previous_emp_code", previousEmpCode);
            data.append("is_rejoined", isRejoined);
            data.append("is_old_employee", isOldEmployee);
            data.append("old_code", oldCode);
            data.append("reference_history", JSON.stringify(referenceHistory));

            const res = await axios.put(
                `${backUrl}/api/emp/candidates-form/${c_id}/`,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        c_id,
                    },
                }
            );

            toast.success("Form submitted successfully!");

            setTimeout(() => {
                window.close();
            }, 3000);
            setErrors({});
        } catch (error) {
            if (error.response?.status === 400) {
                const data = error.response.data;

                if (data.message) {
                    toast.error(data.message);
                    return;
                }

                Object.entries(data).forEach(([field, messages]) => {
                    if (Array.isArray(messages)) {
                        messages.forEach((msg) => toast.error(msg));
                    } else {
                        toast.error(messages);
                    }
                });

                setErrors(data);
            } else {
                toast.warn("Please fix validation errors.");
            }
        }
    };

    // Show loading spinner while validating the link
    if (formBlocked === null) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>
                <div style={{ fontSize: 18, color: '#0e497b', marginBottom: 12 }}>Validating your link...</div>
            </div>
        );
    }

    // Show error if link is invalid / already submitted
    if (formBlocked) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Arial, sans-serif', padding: 24 }}>
                <div style={{ maxWidth: 480, textAlign: 'center', padding: '40px 32px', border: '1px solid #ffa39e', borderRadius: 12, background: '#fff2f0' }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
                    <h2 style={{ color: '#cf1322', marginBottom: 12 }}>Link Unavailable</h2>
                    <p style={{ color: '#555', fontSize: 15 }}>{formBlocked}</p>
                    <p style={{ color: '#888', fontSize: 13, marginTop: 16 }}>If you believe this is an error, please contact HR.</p>
                </div>
            </div>
        );
    }
    return (
        <>
            <Loginheader />
            <ToastContainer position="top-center" autoClose={3000} />

            <Modal
                open={askEmployee}
                footer={null}
                closable={false}
                centered
            >
                <p style={{ fontSize: "16px", fontWeight: 500 }}>
                    Have you previously worked in any company under Baashyaam Group?
                </p>

                <div style={{ marginTop: "20px" }}>
                    <label style={{ marginRight: "20px" }}>
                        <input
                            type="radio"
                            name="selectedOption"
                            value="yes"
                            onChange={() => {
                                setSelectedOption(true)
                                setIsRejoined(true)
                            }}
                        />{" "}
                        Yes
                    </label>

                    <label>
                        <input
                            type="radio"
                            name="selectedOption"
                            value="no"
                            onChange={() => {
                                setSelectedOption(false)
                                setIsRejoined(true)
                            }}
                        />{" "}
                        No
                    </label>
                </div>



                {selectedOption && (
                    <Form layout="vertical" style={{ marginTop: "20px" }}>

                        <Row gutter={16}>

                            <Col span={12}>
                                <Form.Item
                                    label="Previous Employee Code"
                                    name="previous_emp_code"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your previous employee code",
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter previous employee code"
                                        value={previousEmpCode}
                                        onChange={(e) => setPreviousEmpCode(e.target.value)}
                                        style={{ height: "40px" }}
                                    />
                                    <Button className="mt-2" onClick={verifyEmployee}>Verify</Button>

                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                )}

                {selectedOption === true && (
                    <>
                        {prevEmp && prevEmp.length > 0 ? (
                            <div style={{ marginTop: "15px" }}>
                                <p><b>Name:</b> {prevEmp[0]?.user?.first_name} {prevEmp[0]?.user?.last_name}</p>
                                <p><b>Organisation:</b> {prevEmp[0]?.organisation_name}</p>
                                <p><b>Department:</b> {prevEmp[0]?.department_name}</p>
                                <p><b>Designation:</b> {prevEmp[0]?.designation_name}</p>
                            </div>
                        ) : (
                            <p style={{ marginTop: "15px", color: "red" }}>
                                Enter Employee Code Correctly
                            </p>
                        )}
                    </>
                )}

                {(
                    selectedOption === false ||           // User selected NO
                    (selectedOption === true && prevEmp?.length > 0) // YES + data exists
                ) && (
                        <div style={{ marginTop: "25px", textAlign: "right" }}>
                            <button
                                style={{
                                    padding: "6px 14px",
                                    borderRadius: "6px",
                                    background: "#0e497b",
                                    border: "none",
                                    color: "white",
                                    cursor: "pointer",
                                }}
                                onClick={() => setAskEmployee(false)}
                            >
                                Continue
                            </button>
                        </div>
                    )}

                {/* <div style={{ marginTop: "25px", textAlign: "right" }}>
                    <button
                        style={{
                            padding: "6px 14px",
                            borderRadius: "6px",
                            background: "#0e497b",
                            border: "none",
                            color: "white",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            if (selectedOption !== true && selectedOption !== false) {
                                toast.warn("Please select Yes or No");
                                return;
                            }
                            setAskEmployee(false);
                        }}
                    >
                        Continue
                    </button>
                </div> */}
            </Modal>

            {!askEmployee && (
                <div
                    className="candidate-bg"
                    style={{
                        backgroundImage: `url(${BackgroundImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        minHeight: "100vh",
                        padding: "40px 20px",
                    }}
                >
                    <motion.div
                        className="candidate-form-container"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.9 }}
                        transition={{ duration: 1.2 }}
                    >
                        <center><h2>Candidate Assessment Form</h2></center>
                        <p style={{ color: "#d32f2f", marginBottom: "16px" }}>
                            * Indicates required fields
                        </p>
                        <center>
                            <Radio.Group
                                value={candidateExp}
                                onChange={(e) => setCandidateExp(e.target.value)}
                                optionType="button"
                                buttonStyle="solid"
                            >
                                <Radio.Button style={{
                                    backgroundColor: candidateExp === "fresher" ? "#0e497b" : "#f0f0f0",
                                    color: candidateExp === "fresher" ? "white" : "black",
                                    borderColor: candidateExp === "fresher" ? "#0e497b" : "#d9d9d9",
                                }} value="fresher">Fresher</Radio.Button>
                                <Radio.Button style={{
                                    backgroundColor: candidateExp === "experienced" ? "#0e497b" : "#f0f0f0",
                                    color: candidateExp === "experienced" ? "white" : "black",
                                    borderColor: candidateExp === "experienced" ? "#0e497b" : "#d9d9d9",
                                }} value="experienced">Experienced</Radio.Button>
                            </Radio.Group>
                        </center>
                        <br />


                        <form className="form-grid" onSubmit={handleSubmit}>
                            <div className="form-columns">

                                {/* LEFT COLUMN */}
                                <div className="form-column">
                                    <div className="form-group">
                                        <label>Salutation *</label>
                                        <select name="salutation" onChange={handleChange} required>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Ms">Ms</option>
                                            <option value="Dr">Dr</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Candidate Name *</label>
                                        <input type="text" name="candidate_name" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Mobile Number *</label>
                                        <input type="tel" name="mobile_number" maxLength="10" onChange={handleChange} required />
                                        {errors.mobile_number && <p className="error-text">{errors.mobile_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Email ID *</label>
                                        <input type="email" name="email_id" onChange={handleChange} required />
                                        {errors.email && <p className="error-text">{errors.email}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Aadhaar Number *</label>
                                        <input type="text" name="aadhaar" maxLength="12" onChange={handleChange} required />
                                        {errors.aadhaar && <p className="error-text">{errors.aadhaar}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>PAN Number</label>
                                        <input type="text" name="pan" onChange={handleChange} />
                                        {errors.pan && <p className="error-text">{errors.pan}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Address</label>
                                        <textarea name="address" rows="2" onChange={handleChange}></textarea>
                                    </div>

                                    <div className="form-group">
                                        <label>Upload Resume *</label>
                                        <input type="file" name="candidate_cv" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Upload Photo * (only professional photo is acceptable)</label>
                                        <input type="file" name="candidate_photo" onChange={handleChange} required />
                                    </div>
                                </div>

                                {/* RIGHT COLUMN */}
                                <div className="form-column">
                                    <div className="form-group">
                                        <label>State</label>
                                        <input type="text" name="state" onChange={handleChange} />
                                    </div>

                                    <div className="form-group">
                                        <label>City</label>
                                        <input type="text" name="city" onChange={handleChange} />
                                    </div>

                                    <div className="form-group">
                                        <label>Pincode</label>
                                        <input type="number" name="pincode" maxLength="6" onChange={handleChange} />
                                    </div>

                                    <div className="form-group">
                                        <label>Education Background *</label>
                                        <textarea name="education_background" rows="2" onChange={handleChange} required></textarea>
                                    </div>

                                    <div className="form-group">
                                        <label>Technical Background *</label>
                                        <textarea name="technical_background" rows="2" onChange={handleChange} required></textarea>
                                    </div>

                                    <div className="form-group">
                                        <label>Relevant Experience *</label>
                                        <input type="number" step="any" name="relevant_experience" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Total Experience *</label>
                                        <input type="number" step="any" name="total_experience" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Specification *</label>
                                        <input type="text" name="specification" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Present Salary *</label>
                                        <input type="number" name="present_salary" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Expected Salary *</label>
                                        <input type="number" name="expected_salary" onChange={handleChange} required />
                                    </div>

                                    <div className="form-group">
                                        <label>Notice Period *</label>
                                        <input type="text" name="notice_period" onChange={handleChange} required />
                                    </div>
                                </div>
                            </div>

                            {
                                candidateExp !== "fresher" && (
                                    <>
                                        <div className="form-group full-width">
                                            <h3 style={{ marginTop: "20px" }}>Reference Details</h3>
                                            {/* Add More Button */}
                                            <button
                                                type="button"
                                                onClick={addReferenceRow}
                                                style={{
                                                    background: 'transparent',
                                                    border: "1px solid green",
                                                    color: "green",
                                                    padding: "6px 12px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    marginBottom: "20px",
                                                    width: 'fit-content'
                                                }}
                                            >
                                                +
                                            </button>

                                            {referenceHistory.map((ref, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        padding: "15px",
                                                        marginBottom: "15px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "6px",
                                                        background: "rgba(255,255,255,0.6)"
                                                    }}
                                                >
                                                    <div className="form-group">
                                                        <label>Referral Name *</label>
                                                        <input
                                                            type="text"
                                                            required
                                                            value={ref.referal_name}
                                                            onChange={(e) =>
                                                                handleReferenceChange(index, "referal_name", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Referral Designation *</label>
                                                        <input
                                                            type="text"
                                                            required
                                                            value={ref.referal_designation}
                                                            onChange={(e) =>
                                                                handleReferenceChange(index, "referal_designation", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Referral Mobile Number *</label>
                                                        <input
                                                            type="text"
                                                            maxLength="10"
                                                            required
                                                            value={ref.referal_mobile_number}
                                                            onChange={(e) =>
                                                                handleReferenceChange(index, "referal_mobile_number", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Referral Email ID *</label>
                                                        <input
                                                            type="email"
                                                            required
                                                            value={ref.referal_email_id}
                                                            onChange={(e) =>
                                                                handleReferenceChange(index, "referal_email_id", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={() => removeReferenceRow(index)}
                                                        style={{
                                                            background: "red",
                                                            color: "white",
                                                            border: "none",
                                                            padding: "5px 10px",
                                                            borderRadius: "4px",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            ))}

                                        </div>
                                    </>
                                )
                            }


                            <div className="form-group full-width">
                                <button type="submit" className="submit-btn">
                                    <img id="submit-logo" src={submitLogo} alt="submit-logo" />
                                    Submit
                                </button>
                            </div>
                        </form>
                    </motion.div>
                </div>
            )}
        </>
    );
}
